import React, { Component } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  // Tooltip,
  // OverlayTrigger,
} from "react-bootstrap";
import MaterialTable, { MTableAction } from "material-table";
import CustomContentAlert, { navigationButtons } from "../helper";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import { SuperAdminAction } from "../../Actions";
import isEqual from "lodash/isEqual";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import SetPermission from "./SetPermission";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import _ from "lodash";
import PermissionModel from "./PermissionModel";

class AddUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      country_code: "",
      phone: "",
      user_type: "",
      property_id: this.props.PropertyId,
      property: this.props.property,
      validFirstName: true,
      validLastName: true,
      validEmail: true,
      validPhone: true,
      validUserType: true,
      formIsValid: false,
      searchValue: "",
      searchedUser: [],
      userList: [],
      propertyList: [],
      api_response: false,
      api_error_message: "",
      api_success_message: "",
      show_alert: false,
      show_error: false,
      nameError: {
        error: false,
        label: "",
        helperText: "",
        validateInput: false,
      },
      setNameError: {
        error: false,
        label: "",
        helperText: "",
        validateInput: false,
      },
      modelOpenClose: false,
      modelPermissionOpenClose: false,
      module_permissions: {},
      userDataToBeEdited: {},
    };
    this.addActionRef = React.createRef();
  }

  componentDidMount = async () => {
    let PropertyId = this.props.PropertyId;

    if (this.props.user_type === "superadmin") {
      const searchParams = this.props?.location?.search;
      PropertyId = searchParams ? searchParams.split("?")[1] : "";
    }
    this.setState({ loader: true }, async () => {
      await this.props.fetchUsers(PropertyId);
      await this.props.get_all_properties();
      this.setState(
        {
          highsecurity: this.props.userList[0]?.high_security,
          userList: this.props.userList,
          propertyList: this.props.getAllProperties,
          loader: false,
          api_response: this.props.api_response,
          property_id: PropertyId,
          modelOpenClose: this.props.modelOpenClose,
          userTypes: this.props.allUserTypes,
        },
        () => {
          let selectedPropertyName;
          let selectedDomainName;

          const selectedPropertyObj = this.state.propertyList?.filter((item) => item.id === this.state.property_id);

          selectedPropertyName = selectedPropertyObj?.[0]?.site_name;
          selectedDomainName = selectedPropertyObj?.[0]?.domain;
          if (selectedPropertyObj.length === 0) {
            selectedPropertyName = this.props?.property?.property_name;
            selectedDomainName = this.props?.property?.domain;
          }

          this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
        },
      );
    });
    await this.props.fetchAllUserTypes();
  };

  componentDidUpdate = (prevProps) => {
    this.props.userList.forEach(function (item) {
      delete item.password;
    });
    if (!isEqual(prevProps.userList, this.props.userList)) {
      this.setState({ userList: this.props.userList });
    }
    if (prevProps.modelOpenClose !== this.props.modelOpenClose) {
      this.setState({ modelOpenClose: this.props.modelOpenClose });
    }
  };

  handleSubmit = async (form_data) => {
    await this.props.addUser(form_data);
    if (this.props.api_response) {
      this.setState(
        {
          show_alert: true,
          api_success_message: this.props.api_success_message,
        },
        () => {
          this.hideAlert();
        },
      );
    } else {
      this.setState(
        {
          show_error: true,
          api_error_message: this.props.api_error_message,
        },
        () => {
          setTimeout(() => {
            this.setState({ show_error: false });
          }, 4000);
        },
      );
    }
  };

  hideAlert = () => {
    setTimeout(() => {
      this.setState({
        show_alert: false,
      });
    }, 4000);
  };

  handleUserEdit = async (editData) => {
    await this.props.editUser({
      ...editData,
      old_data: this.state.userList.find((x) => x.id === editData.id),
    });
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      this.hideAlert();
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  handleUserDelete = async (userId) => {
    await this.props.deleteUser(userId, this.state.property_id);
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      this.hideAlert();
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  PhoneValidation = (rowData) => {
    if (Object.keys(rowData).length !== 0 && "phone" in rowData) {
      if (rowData?.phone === "") {
        return "Phone number is required!";
      } else if (rowData?.phone?.length >= 11 || rowData?.phone?.length < 10) {
        return "Please  enter valid Phone Number";
      } else if (!/^\d+$/.test(rowData.phone)) {
        return "Please  enter valid Phone Number";
      }
    }
    return "";
  };

  handlePermissionClick = (rowData) => {
    this.setState({
      modelPermissionOpenClose: true,
      users_permission: rowData?.user_types_permission,
    });
  };

  handlePermissionModelClose = () => {
    this.setState({
      modelPermissionOpenClose: false,
      users_permission: [],
    });
  };

  AddRow = () => {
    this.setState({
      modelOpenClose: true,
      users_permission: [],
    });
  };

  EditRow = (rowData) => {
    this.setState({
      modelOpenClose: true,
      userDataToBeEdited: rowData,
    });
  };

  DeleteRow = async (rowData) => {
    const confirmation = window.confirm("Are you sure you want to delete this entry?");
    if (confirmation) {
      this.handleUserDelete(rowData.id);
    }
  };

  handleClose = () => {
    this.setState({
      modelOpenClose: false,
      userDataToBeEdited: {},
    });
  };

  handleUserPermission = (userPermissions, userData, isEdit) => {
    const module_permissions = [];
    !_.isEmpty(userPermissions) &&
      userPermissions.map((ele) => {
        module_permissions.push({
          permission_module_name: ele.label,
          is_active: ele.is_active,
          permission_module_id: ele.permission_module_id,
        });
        return ele;
      });

    this.setState({
      module_permissions: module_permissions,
    });
    const new_form_data = {
      property_id: this.state.property_id,
      first_name: userData.Firstname,
      last_name: userData.Lastname,
      username: userData.Username,
      country_code: userData.country_code,
      phone: userData.Phone,
      user_type: userData.userType,
      user_sub_type: userData.userSubType,
      email: userData.Email,
      password: userData.password,
    };
    if (!isEdit) {
      this.handleSubmit(new_form_data);
    } else {
      new_form_data.id = userData.id;
      this.handleUserEdit(new_form_data);
    }
    this.handleClose();
  };

  handleActionField = (props) => {
    if (typeof props.action === typeof Function || props.action.tooltip !== "Add") {
      return <MTableAction {...props} />;
    } else {
      return <div ref={this.addActionRef} onClick={props.action.onClick} />;
    }
  };

  handleIconField = () => (
    <Button className="btn-blue-bg" data-mycustomid={"add-icon-handler"}>
      Add User
    </Button>
  );

  handleValidEmail = (rowData) => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (rowData.email === "") {
      return "Email is required!";
    } else if (!regex.test(rowData?.email)) {
      return "Please enter valid email.";
    } else {
      return "";
    }
  };

  handlePassword = (props) => {
    return <TextField type="password" value={props.value} autoComplete="off" onChange={(e) => props.onChange(e.target.value)} />;
  };

  render() {
    const {
      loader,
      userList,
      api_success_message,
      api_error_message,
      show_alert,
      show_error,
      modelOpenClose,
      modelPermissionOpenClose,
      highsecurity,
      users_permission,
    } = this.state;
    this.columns = [
      {
        title: "Email",
        field: "email",
        type: "email",
        //  readonly: true,
        validate: (rowData) => this.handleValidEmail(rowData),
      },
      {
        title: "First Name",
        field: "first_name",
        validate: (rowData) => (rowData.first_name === "" ? "First name is required!" : ""),
      },
      {
        title: "Last Name",
        field: "last_name",
        validate: (rowData) => (rowData.last_name === "" ? "Last name is required!" : ""),
      },
      {
        title: "Username",
        field: "username",
        validate: (rowData) => (rowData.last_name === "" ? "User name is required!" : ""),
      },
      {
        title: "Country Code",
        field: "country_code",
        validate: (rowData) => (rowData.country_code.length > 4 ? "Please enter proper country code" : ""),
      },
      {
        title: "Phone",
        field: "phone",
        validate: (rowData) => this.PhoneValidation(rowData),
      },
      {
        title: "Password",
        field: "password",
        render: () => <p>--</p>,
        editComponent: (props) => this.handlePassword(props),
      },
      {
        title: "User Type",
        field: "user_type",
        // lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) => (rowData.user_type === "" ? "User type is required!" : ""),
      },
      {
        title: "User Sub Type",
        field: "user_sub_type",
        //  lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) => (rowData.user_sub_type === "" ? "User sub type is required!" : ""),
        render: (rowData) => (
          <a className={"d-flex cursor-pointer"} onClick={() => this.handlePermissionClick(rowData)}>
            {rowData.user_sub_type}
          </a>
        ),
      },
      {
        title: "Action",
        field: "-",
        render: (rowData) =>
          !modelOpenClose && (
            <div className={"d-flex"}>
              <CustomButton className={"mr-2"} onClick={() => this.EditRow(rowData)}>
                <Edit />
              </CustomButton>
              <CustomButton className={"ml-2"} onClick={() => this.DeleteRow(rowData)}>
                <Delete />
              </CustomButton>
            </div>
          ),
      },
    ];
    if (highsecurity === 1) {
      this.columns.push({
        title: "Last Login",
        field: "last_acessed_at",
        //  lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) => rowData.last_acessed_at,
      });
    }
    return (
      <>
          <Row className="h-100">
            <Col md="12">
              <Card className="h-100">
                <Card.Header>
                  {this.props.user_type === "superadmin" && window.location.pathname !== "/manage-admin" ? (
                    <Card.Title as="h4">Manage Users</Card.Title>
                  ) : (
                    <Card.Title as="h4">Manage Admin</Card.Title>
                  )}

                  <p className="card-category"></p>
                </Card.Header>
                <Card.Body className="uer-list">
                  {loader ? (
                    <Loader />
                  ) : (
                    <StyledDiv style={{ maxWidth: "100%" }}>
                      <MaterialTable
                        title=""
                        components={{
                          Action: this.handleActionField,
                        }}
                        options={{
                          actionsColumnIndex: -1,
                          addRowPosition: "first",
                          draggable: false,
                        }}
                        columns={this.columns}
                        data={userList}
                        icons={{
                          Add: this.handleIconField,
                          hidden: true,
                        }}
                        actions={[{ hidden: true }]}
                      />
                    </StyledDiv>
                  )}
                  {this.props.user_type === "superadmin" && window.location.pathname !== "/manage-admin" ? (
                    <Col lg="12" className="p-0">
                      {navigationButtons(
                        "/settings",
                        "/permissions",
                        this.state.property_id,
                        this.addActionRef,
                        "Add User",
                        null,
                        null,
                        () => {
                          const history = require("../../history").default;
                          history.push({
                            pathname: "/permissions",
                            search: this.state.property_id,
                          });
                        },
                        () => {
                          this.AddRow();
                        },
                      )}
                    </Col>
                  ) : (
                    <Col lg="12" className="p-0 mt-2">
                      <Button
                        className="btn-blue-bg"
                        onClick={() => {
                          this.AddRow();
                        }}
                      >
                        {"Add Admin"}
                      </Button>
                    </Col>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        {modelOpenClose && (
          <SetPermission
            modelOpenClose={modelOpenClose}
            handleClose={this.handleClose}
            propertyId={this.state.property_id}
            highSecurity={this.props.highSecurity}
            handleUserPermission={this.handleUserPermission}
            userDataToBeEdited={this.state.userDataToBeEdited}
            userTypes={this.props.allUserTypes}
          />
        )}
        {modelPermissionOpenClose && (
          <PermissionModel
            modelPermissionOpenClose={modelPermissionOpenClose}
            handleClose={this.handlePermissionModelClose}
            users_permission={users_permission}
          />
        )}
        {show_alert && <CustomContentAlert delay={4000} message={api_success_message} className="toast-success" />}
        {show_error && <CustomContentAlert delay={5000} message={api_error_message} className="toast-error" />}
      </>
    );
  }
}

const mapStateToProps = ({ SuperAdminDetails, APIResponseDetails, UserProfileDetails }) => {
  const { getAllProperties, userList, modelOpenClose, allUserTypes, highSecurity } = SuperAdminDetails;
  const { api_response, api_success_message, api_error_message } = APIResponseDetails;
  const { property, property_id: PropertyId, id, user_type } = UserProfileDetails;
  return {
    userList,
    getAllProperties,
    api_response,
    api_success_message,
    api_error_message,
    modelOpenClose,
    allUserTypes,
    highSecurity,
    PropertyId,
    property,
    id,
    user_type,
  };
};

const mapStateToDispatch = {
  addUser: SuperAdminAction.addUser,
  fetchUsers: SuperAdminAction.fetchUsers,
  editUser: SuperAdminAction.editUser,
  deleteUser: SuperAdminAction.deleteUser,
  get_all_properties: SuperAdminAction.get_all_properties,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  fetchAllUserTypes: SuperAdminAction.get_all_user_types,
};

export default connect(mapStateToProps, mapStateToDispatch)(AddUserForm);
const CustomButton = styled(Button)`
  height: 40px;
  width: 40px;
  border-radius: 25px;
  padding: 5px;
`;
const StyledDiv = styled.div`
  max-width: 100%;
  table > thead {
    th:last-child {
      display: none;
    }
  }
  table > tbody {
    td:last-child {
      display: none;
    }
  }
`;
